import React from 'react';
import { hasPermission } from '../utils/helper';

const PermissionWrapper = ({ module, permission, mainModule, children }) => {
  const hasAccess = hasPermission(module, permission, mainModule);

  if (hasAccess) {
    return <>{children}</>;
  }

  return null;
};

export default PermissionWrapper;
